<template>
  <div class="table">
    <!--=========查询模块================-->
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="用户名" prop="name">
                <el-input class="handle-input" clearable v-model.trim="queryCondition.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="用户账号" prop="emplid">
                <el-input class="handle-input" clearable v-model.trim="queryCondition.emplid"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="联系邮箱" prop="email">
                <el-input class="handle-input" clearable v-model.trim="queryCondition.email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" prop="phone">
                <el-input class="handle-input" clearable v-model.trim="queryCondition.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="search">{{$t('common.search')}}</el-button>
            <el-button type="primary" @click="restQueryForm">{{$t('common.reset')}}</el-button>

          </el-row>
        </el-form>
      </div>
      <div class="toolsBox">
        <el-button type="primary" @click="pickUp">{{$t('common.confirm')}}</el-button>
        <el-button type="primary" v-if="puMulti == true" @click="toggleSelection">{{$t('common.Deselected')}}</el-button>
      </div>
      <el-table :data="tableData" ref="pickUserTable" row-key="tmUserId" border style="margin-top:20px" max-height='350' @selection-change="selectionChange" highlight-current-row>
        <el-table-column v-if="puMulti == true" prop="tmUserId" type="selection" width="55" align="center" :reserve-selection="true" />
        <el-table-column v-else width="100" :label="$t('common.select')" prop="name">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.tmUserId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="用户名"></el-table-column>
        <el-table-column prop="emplid" label="用户账号"></el-table-column>
        <el-table-column prop="email" label="联系邮箱"></el-table-column>
        <el-table-column prop="phone" label="联系电话"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { userService } from "@/api/user-manage/user";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";

export default {
  name: "pickupUser",
  props: {
    value: String,
    title: String,
    multi: Boolean,
    placeholder: String,
    emplFlag: String,
    selectDatas: Array, //useless by now
    SelectedDefault: Boolean,
    SelectedDefaultId: Array,
  },
  data() {
    return {
      selectRows: [],
      puMulti: this.multi,
      puPlaceholder: this.placeholder,
      tableData: [],
      radioVal: null,
      selectedId: this.value,
      selectDataAll: this.multi
        ? {
          defaultData: commonFun.convertToArray(this.value),
          pageDatas: []
        }
        : null,
      totalCount: 0,
      labelPosition: "right",
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        name: "",
        emplid: "",
        email: '',
        phone: ''
      },
      showDialog: false,
      notSelRoles: [],
      selRoles: [],
      userId: null,
      userInfo: {},
      showUserInfo: false,
      selectedTouched: {}
    };
  },
  created() {
    console.log(this.emplFlag)
    if(this.SelectedDefaultId && this.SelectedDefaultId.length) {
      // Init all selected defaults to untouched state
      this.SelectedDefaultId.forEach(data => {
        this.selectedTouched[data.tmUserId] = false;
      });
    }
    this.queryData();
  },
  computed: {
    getSelectedData() {
    },

    transferTo() {
      return this.value;
    }
  },
  watch: {
    value(newVal) {
      console.log(newVal);
    }
  },
  methods: {
    toggleSelection() {
      this.$refs.pickUserTable.clearSelection();
      for(let k in this.selectedTouched) {
        this.selectedTouched[k] = true;
      }
    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRows = [];
      this.selectRows = row;
    },
    queryData() {
      var that = this;
      this.queryCondition.emplFlag = this.emplFlag
      userService
        .getUsers(this.queryCondition)
        .then(res => {
          this.tableData = res.resultData;
          this.totalCount = res.totalCount;
        })
        .then(value => {
          if (that.SelectedDefault) {
            //默认选中
            that.$nextTick(() => {
              that.selectedDefaultFun()
            });
          }
        });
    },
    selectedDefaultFun() {
      var that = this;
      let userIds = that.SelectedDefaultId;
      if (userIds.length > 0) {
        userIds.forEach((data) => {
          // Only untouched defaults will be selected on table
          if (!that.selectedTouched[data.tmUserId]) {
            that.tableData.forEach((row, i) => {
              if (row.tmUserId == data.tmUserId) {
                that.$refs["pickUserTable"].toggleRowSelection(row, true);
                that.selectedTouched[data.tmUserId] = true;
              }
            });
          }
        });
      }
    },
    search() {
      this.queryCondition.pageNum = 1
      this.queryData();
    },
    pickUp() {
      console.log(this.$refs["pickUserTable"].layout.store.$data.states.selection, 'this.$refs["pickUserTable"].layout.store.$data.states.selection');
      console.log(this.selectRows, 'this.selectRows');
      if (this.multi) {//多选
        this.mergeSelectedDefaults();
        this.$emit("input", this.selectRows);
      } else {
        this.$emit("input", this.selectRows.name, this.selectRows.tmUserId);
        this.$emit("getEmail", this.selectRows.email);
        this.$emit("selectRows", this.selectRows);
      }
    },
    selectionChange(rows) {
      let that = this;
      this.selectRows = [];
      if (rows) {
        rows.forEach(val => {
          if (that.selectRows.every(row => row.tmUserId != val.tmUserId)) {
            that.selectRows.push(val);
          }
        });
      }
    },
    mergeSelectedDefaults() {
      // Merge selected defaults to final result selectRows
      // Only untouched defaults need to be merged, touched defaults are managed by table selection itself
      if (this.SelectedDefault && this.SelectedDefaultId && this.SelectedDefaultId.length) {
        this.SelectedDefaultId.forEach((data) => {
          if (!this.selectedTouched[data.tmUserId]) {
            if (this.selectRows.every(row => row.tmUserId != data.tmUserId)) {
              this.selectRows.push(data);
            }
          }
        });
        console.log(this.selectRows, 'merged selectRows');
      }
    },
    //页码变化
    pageNumberChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
    //显示条数变更
    pageSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        name: "",
        emplid: "",
        email: '',
        phone: ''
      }
      this.$refs.pickUserTable.clearSelection();
      this.queryData();
    },
    editUserInfo(row) {
      this.userInfo = {};
      this.clearVlidate("userInfoForm");
      this.userInfo = row;
      this.showUserInfo = true;
    },
    updateCheck() { // The method is error prone, recheck before use!
      if (!this.puMulti) {
        if (!commonFun.isEmpty(this.selectDataAll)) {
          this.tableData.forEach(row => {
            if (row.tmUserId == this.selectDataAll.tmUserId) {
              this.selectedId = row.tmUserId;
              this.selectDataAll = row;
            }
          });
        }
      } else {
        var that = this;
        let defaultData = this.selectDataAll.defaultData;
        let existsArr = [];
        defaultData.forEach((data, i) => {
          if (commonFun.isNotEmpty(data)) {
            that.tableData.forEach(row => {
              if (row.tmUserId == data.tmUserId) {
                that.$refs["pickUserTable"].toggleRowSelection(row, true);
                existsArr.push(i);
              }
            });
          }
        });
        existsArr.forEach(i => {
          this.selectDataAll.defaultData.splice(i, 1);
        });
      }
    }
  }
};
</script>
<style scoped>
.handle-input {
  width: 95%;
}

.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

/*穿梭框样式重写*/
.el-transfer .el-transfer-panel {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  display: inline-block;
  vertical-align: middle;
  width: 255px;
  max-height: 100%;
  box-sizing: border-box;
  position: relative;
}

.el-transfer-panel__body {
  height: 370px;
}

.el-transfer-panel__list.is-filterable {
  height: 360px;
}
</style>
